<template>
  <div>
    <div class="hint p-2 mt-1 mb-1 border-radius">
      {{ $t('vform.navigationSettingsInfo') }}
    </div>
    <label class="vform-label mb-0">{{ $t('vform.filter') }}</label>
    <content-filter
        v-if="organizationId"
        :id="element.uuid"
        :display-inline="true"
        :initial-state-filter="['a']"
        :initial-type-filter="['vstage']"
        :limit-to-organization-ids="[organizationId]"
        :state-filter-items="['a']"
        :tag-filtering="true"
        :store-previous-values="false"
        :initial-text-filter="searchText"
        :initial-tag-filter="initialTags"
        class="mb-2 mt-0"
        store-name="Project"
        type="miniFilter"
        @filter="saveFilter"
        :key="forceReRenderKey"
    />
    <label class="vform-label mt-1 mb-1">{{ $t('vform.sort') }}</label>
    <drop-down
        :labels="sortOptions.map(o => o.name)"
        :values="sortOptions.map(o => o.fieldname)"
        :initial-active-value="sorting"
        class="w-100"
        @select="saveSorting"
    />
    <label class="vform-label mt-3 mb-1">{{ $t('vform.limit') }}</label>
    <input type="number"
           class="vform-input w-100 form-text form-text-dark"
           v-model.number="element.settings.limit"
           min="1"
           :max="vformSettings.MAX_LIMIT_DYNAMIC_NAVIGATION"
    >
    <div class="form-error mt-1" v-if="element.settings.limit > vformSettings.MAX_LIMIT_DYNAMIC_NAVIGATION">
      {{ $t('vform.maximumLimitIs', {limit: vformSettings.MAX_LIMIT_DYNAMIC_NAVIGATION}) }}
    </div>
    <div class="form-error mt-1" v-if="element.settings.limit < 1">
      {{ $t('vform.minimumLimitIs', {limit: 1}) }}
    </div>
    <alignment-editor
        :selected-template="selectedTemplate"
        :element="element"
    />
    <div class="dflex mt-3">
      <div class="col row">
        <label class="vform-editor-label section mt-0">{{ $t('vform.alignment') }}</label>
      </div>
      <set-by-template v-if="selectedTemplate && selectedTemplate.alignment"/>
      <div
          v-else
          v-for="(align, index) in alignments"
          :key="index"
          :class="['vform-alignment-button', align === element.alignment ? 'active' : '']"
          @click="setAlignment(align)">
        <icon :type="'align-' + align" size="1"/>
      </div>
    </div>
    <div class="col pl-0 pr-0 dflex" v-if="state && state.isTopBottomBarPanel">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{ $t("showInline") }}</label>
      </div>
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <label :for="'showInline' + $vnode.key" class="container" style="padding-left: 5px !important">
          <input :id="'showInline' + $vnode.key" v-model="element.isInline" type="checkbox">
          <span class="checkmark"/>
        </label>
      </div>
    </div>
    <label class="vform-editor-label section">{{ $t('vform.backgroundColor') }}</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
    <color-picker-and-field
        v-else
        :field-background-color="element.backgroundColor ? element.backgroundColor : null"
        @saveColor="(color) => {setItemColor('backgroundColor', color)}"
        @unsetColor="setItemColor('backgroundColor', null)"
    />

    <label class="vform-editor-label section">{{ $t('vform.borderColor') }}</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
    <color-picker-and-field
        v-else
        :field-background-color="element.borderColor"
        @saveColor="(color) => {setItemColor('borderColor', color)}"
        @unsetColor="setItemColor('borderColor', null)"
    />

    <label class="vform-editor-label section">{{ $t('vform.fontColor') }}</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
    <color-picker-and-field
        v-else
        :field-background-color="element.fontColor"
        @saveColor="(color) => {setItemColor('fontColor', color)}"
        @unsetColor="setItemColor('fontColor', null)"
    />
  </div>
</template>

<script>
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js.vue";
import ContentFilter from "@/components/widgets/filter/ContentFilter.vue";
import DropDown from "@/components/forms/DropDown.vue";
import SetByTemplate from "@/components/vForm/SetByTemplate.vue";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import {vformSettings} from "@/enum";
import AlignmentEditor from "@/components/vForm/AlignmentEditor.vue";
import Icon from "@/components/Icon.vue";
export default {
  name: "vFormNAVIGATION",
  components: {
    AlignmentEditor,
    ColorPickerAndField,
    SetByTemplate,
    ContentFilter,
    DropDown,
    Icon
  },
  mixins: [vFormElementMixin],
  data() {
    return {
      vformSettings,
      forceReRenderKey: 0,
      alignments: ["left", "center", "right", "justify"],
      initialTags: [],
      sortOptions: [
        {
          name: 'Name (A-Z)',
          fieldname: '+name'
        },
        {
          name: 'Name (Z-A)',
          fieldname: '-name'
        },
        {
          name: 'Created At (newest)',
          fieldname: '-createdAt'
        },
        {
          name: 'Created At (oldest)',
          fieldname: '+createdAt'
        },
        {
          name: 'Updated At (newest)',
          fieldname: '-updatedAt'
        },
        {
          name: 'Updated At (oldest)',
          fieldname: '+updatedAt'
        }
      ]
    }
  },
  computed: {
    sorting() {
      if (this.element && this.element.settings && this.element.settings.sortBy) {
        return this.element.settings.sortBy;
      }
      return '-createdAt';
    },
    filter() {
      if (this.element && this.element.settings && this.element.settings.filter) {
        return this.element.settings.filter.add;
      }
      return {};
    },
    tags() {
      if(!this.filter) {
        return [];
      }
      const {tags} = this.filter;
      if (tags !== undefined) {
        console.log('tags', tags);
        const tagString = Object.values(tags)[0];
        if(tagString.includes(',')) {
          const tagList = tagString.split(',').map(t => t.trim());
          if(tagList.length > 0) {
            return tagList.map(name => {
              return {name};
            });
          }
        } else {
          return [{name: tagString}];
        }
      }
      return [];
    },
    searchText() {
      if(!this.filter) {
        return '';
      }
      const {q} = this.filter;
      if (q) {
        return Object.values(q)[0];
      }
      return '';
    }
  },
  beforeMount() {
    this.listName = this.element.uuid;
    if (!this.element.settings) {
      this.$set(this.element, 'settings', {
        filter: {
          keep: {
            limit: 10,
            offset: 0
          }
        },
        limit: 10,
        sortBy: '+createdAt',
        sortDirection: 'descending',
        pagination: false,
      });
    }
    if(!this.element.textAlignment) {
      this.$set(this.element, 'textAlignment', 'left');
    }
    if(!this.element.alignment) {
      this.$set(this.element, 'alignment', 'left');
    }
    if(this.tags) {
      this.initialTags = this.tags;
    }
    console.log('initial tags', this.tags);
    if (this.element.isInline === undefined) {
      this.$set(this.element, "isInline", false);
    }
  },
  methods: {
    setAlignment(val) {
      this.$set(this.element, "alignment", val);
    },
    setTextAlignment(val) {
      this.$set(this.element, "textAlignment", val);
    },
    saveSorting(fieldName) {
      // todo: check if the value is alreay on the fieldName value, then don't save over
      if(this.element.settings.sortBy === fieldName) {
        return;
      }
      console.log('saveSorting', fieldName);
      console.log('pre-existing filter', this.element.settings.sortBy);
      this.$set(this.element.settings, 'sortBy', fieldName);
      console.log('filter after', this.element.settings.sortBy);
    },
    saveFilter(args) {
      const preExistingFilter = this.element.settings.filter && this.element.settings.filter.add ? this.element.settings.filter.add : {};
      console.log('preExistingFilter', preExistingFilter);
      console.log('add filter', args.add);
      const newAdd = {...preExistingFilter, ...args.add};
      if (args.remove) {
        const removingKeys = Object.keys(args.remove);
        removingKeys.forEach(key => {
          delete newAdd[key];
        });
      }
      delete args.remove;
      this.$set(this.element.settings.filter, 'add', newAdd);
    }
  }
}
</script>

<style scoped lang="scss">
.hint {
  background-color: var(--vform-editor-ui-secondary-color);
}
</style>